import React, { useState, useEffect } from "react";
import ApiService from "../../services/Api.service";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Alert from "../../components/Alert/Alert";
import FilterBar from "../../components/FilterBar/FilterBar";
import DispositionReport from "../../components/Reports/DispositionReport/DispositionReport";
import ChurnReportTable from "../../components/Reports/ChunkReport/ChunkReport";
import { Filter } from "lucide-react";
import Loader from "../../components/Loader/Loader";
import UploadDialog from "./Dialog/UploadDialog";
import toast from "react-hot-toast";

export default function Report() {
    const [Loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState({});
    const [batchOptions, setBatchOptions] = useState([]);
    const [campaignOptions, setCampaignOptions] = useState([]);
    const [reportTypeOptions, setReportTypeOptions] = useState([]);
    const [lastFilters, setLastFilters] = useState({});
    const [alertValue, setAlertValue] = useState({
        show: false,
        message: "",
        variant: "success",
        position: "middle",
    });

    const validationSchema = yup.object().shape({});

    const {
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            campaign_id: "",
            agents: [],
            products: [],
            search: "",
            start_date: "",
            end_date: "",
        },
    });
    const fetchDetail = async (payload = lastFilters) => {
        try {
            setLoading(true);
            if (!payload) {
                payload = {
                    campaign_id: "",
                };
            }
            setLastFilters(payload);
            const res = await ApiService.getReports(payload);
            if (res.status === 200 && res.data) {
                setTableData(res.data.data || {});
            } else {
                setTableData({});
            }
        } catch (error) {
            console.error("fetchDetail error:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchDashboardData = async () => {
        try {
            setLoading(true);
            const campaignRes = await ApiService.getCampaignOptions();
            const campaignData = campaignRes?.data?.data || [];
            setCampaignOptions(campaignData);
            const reportTypeRes = await ApiService.getReportTypeOptions();
            setReportTypeOptions(reportTypeRes?.data || []);

        } catch (err) {
            console.error("Error loading dashboard data:", err);
        } finally {
            setLoading(false);
        }
    };

    const fetchDropdownDetail = async (filters) => {
        try {
            const subprocessRes = await ApiService.getBatchesOptions(filters.campaign_id);

            if (subprocessRes.status === 200) {
                setBatchOptions(subprocessRes.data.data);
            }
        } catch (error) {
            console.error(error);
        }
    };
    useEffect(() => {
        if (lastFilters?.campaign_id) {
            fetchDropdownDetail(lastFilters);
        }
    }, [lastFilters?.campaign_id]);

    useEffect(() => {
        fetchDashboardData();
    }, []);

    const handelSubmit = async (data) => {
        const payload = Object.fromEntries(
            Object.entries(data).filter(([_, v]) => {
                if (Array.isArray(v)) return v.length > 0;
                return v !== "" && v !== null && v !== undefined;
            })
        );
        fetchDetail(payload);
        setLastFilters(payload)
    };

    const handleClearFilters = () => {
        reset({ campaign_id: "" });
        setLastFilters([])
    };

    const getFinalFileName = (file) => {
        const fileName = file.name;
        const fileExtension = fileName.split(".").pop().toLowerCase();
        return fileExtension === "csv"
            ? `${Date.now()}.${fileExtension}`
            : fileName;
    };
    const filterDefs = [
        { type: "multiselect", name: "campaign_list", placeholder: "Select Campaign", options: campaignOptions },
        { type: "select", name: "batch", placeholder: "Select Batch", options: batchOptions },
        { type: "select", name: "report_type", placeholder: "Report Type", options: reportTypeOptions },
        { type: "date", name: "start_date", placeholder: "Start Date" },
        { type: "date", name: "end_date", placeholder: "End Date" },
    ];

    const hasDispositionData = Array.isArray(tableData?.groups) && tableData.groups.length > 0;
    const hasChurnData = Array.isArray(tableData?.column_groups) && tableData.column_groups.length > 0;
    const showEmptyState =
        !Loading &&
        (!lastFilters?.report_type || (!hasDispositionData && !hasChurnData));

    return (
        <>
            {alertValue.show && (
                <Alert
                    variant={alertValue.variant}
                    message={alertValue.message}
                    dismissible={true}
                    timeout={2500}
                    position={alertValue.position}
                    onClose={() => setAlertValue({ show: false, message: "", variant: "" })}
                />
            )}

            <div className="main-contanier">
                <FilterBar
                    control={control}
                    handleSubmit={handleSubmit}
                    onSubmit={handelSubmit}
                    onClearFilters={handleClearFilters}
                    filters={filterDefs}
                    title={"Reports"}
                    totalCount={0}
                    tableId="table-id"
                    isDownload={true}
                    isServerExport={false}
                    isUpload={false}
                />
            </div>
            {Loading && (
                <div style={{ padding: 16 }}>
                    <Loader />
                </div>
            )}
            {showEmptyState && (
                <div className="report-table-container"
                    style={{
                        minHeight: "400px",
                        textAlign: "center",
                        color: "rgb(155 171 192)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        border: "1px solid #efe8e8"
                    }}
                >
                    <Filter size={20} />
                    Click on Filters. Select a campaign and report type to view the report.
                </div>
            )}
            {lastFilters.report_type == "disposition_summary" && (
                <DispositionReport data={tableData} />
            )}
            {lastFilters.report_type == "churn_summary" && (
                <ChurnReportTable data={tableData} />
            )}
            {lastFilters.report_type == "bucket_summary" && (
                <DispositionReport data={tableData} />
            )}

        </>
    );
}
